module.exports = __webpack_public_path__ + "img/bhim@3x.4ed485f4.png";